import { render } from "./AlertBadge.vue?vue&type=template&id=757509d9&ts=true"
import script from "./AlertBadge.vue?vue&type=script&lang=ts"
export * from "./AlertBadge.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__